import React from 'react'

import * as R from 'ramda'

import { Div, Span } from '@driftt/tide-core'
import { Select } from '@driftt/tide-selects'
import { Icon } from '@driftt/tide-icons'

import './style.css'

const defaultSizeOptions = [{label: 25, value: 25}, {label: 50, value: 50}, {label: 75, value: 75}]

const Paginator = ({ totalPages, index, goForward, goBackward, changeSize, size, sizeOptions = defaultSizeOptions}) => {
	const canGoBack = !index
	const canGoForwards = (index + 1) >= totalPages

	return (
		<Div className="accounts-table-paginator">
			<Div className="paginator-size-wrapper">
				<Select
				options={sizeOptions}
				isSearchable={false}
				menuPlacement="auto"
				value={R.find(R.propEq('value', size), sizeOptions)}
				onChange={changeSize}
				className="accounts-table-paginator-size-select" />
			</Div>
			<Div className="paginator-navigation-wrapper">
				<Div className="paginator-navigation">
					{totalPages > 1 && <button onClick={goBackward} disabled={canGoBack}><Icon width={12} height={12} name="arrow-1-left" /></button>}
					<Span>Page {index + 1} of {totalPages || 1}</Span>
					{totalPages > 1 && <button disabled={canGoForwards} onClick={goForward}><Icon width={12} height={12} name="arrow-1-right" /></button>}
				</Div>
			</Div>
		</Div>
	)
}

export default Paginator
